import { ROLES } from 'config';

const homeConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('home', {
      url: '/home',
      template: '<app-home></app-home>',
      access: {
        loginRequired: true,
        roles: [ROLES.USER],
      },
    });
};

export default homeConfig;



// WEBPACK FOOTER //
// ./src/modules/home/home.config.js